import { apiFetchJson } from '@wundo/client/api.ts';

export interface PipelineStats {
  classification: {
    total_messages: number;
    detected: number;
    needing_detection: number;
    questions: number;
    fully_classified: number;
    needing_classification: number;
  };
  session_analysis: {
    total_sessions: number;
    fully_analyzed: number;
    needing_analysis: number;
    analyzers: Record<string, number>;
  };
  reviews: {
    total: number;
    needing_review: number;
    by_severity: {
      critical: number;
      high: number;
      medium: number;
      low: number;
      ok: number;
    };
  };
}

export async function fetchPipelineStats(): Promise<PipelineStats> {
  return apiFetchJson<PipelineStats>('/pipeline-stats');
}
